import React from "react";

const BadgeButton = ({ active, onClick, title, count, styles }) => (
  <button type="button" className={"btn " + (active ? "btn-primary" : "btn-light")} onClick={onClick} style={styles}>
    {title} <span className="badge badge-light">{count}</span>
  </button>
);

export default BadgeButton;
